import { COLOR_SCHEME_CODE_MAP } from "../resource/constants";

const getPrefersColorScheme = () =>
  window.matchMedia &&
  window.matchMedia("(prefers-color-scheme: light)").matches === true
    ? COLOR_SCHEME_CODE_MAP.LIGHT
    : COLOR_SCHEME_CODE_MAP.DARK;

export default getPrefersColorScheme;
